import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { Toaster } from "./ui/sonner";
import { Building2, BarChart3, LogOut, ShieldCheck, Package, Wallet, Receipt, Mail, UserCog, Video } from "lucide-react";

const NAV = [
  { to: "/master", label: "Genel", icon: BarChart3, end: true },
  { to: "/master/isletmeler", label: "İşletmeler", icon: Building2 },
  { to: "/master/paketler", label: "Paketler", icon: Package },
  { to: "/master/abonelikler", label: "Abonelikler", icon: Receipt },
  { to: "/master/odeme-ayarlari", label: "Ödeme Ayarları", icon: Wallet },
  { to: "/master/eposta-ayarlari", label: "E-posta", icon: Mail },
  { to: "/master/yardim-videolari", label: "Yardım Videoları", icon: Video },
  { to: "/master/profil", label: "Profil", icon: UserCog },
];

function NavItem({ to, label, icon: Icon, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={`master-nav-${label.toLowerCase()}`}
      className={({ isActive }) =>
        `group flex items-center gap-3 px-4 py-3 border-l-2 transition-all ${
          isActive
            ? "border-l-amber-500 bg-amber-500 text-foreground"
            : "border-l-transparent text-background/60 hover:text-background hover:bg-foreground/60"
        }`
      }
    >
      <Icon className="h-4 w-4" />
      <span className="text-sm font-semibold tracking-tight">{label}</span>
    </NavLink>
  );
}

export default function MasterLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-foreground text-background">
      <header className="sticky top-0 z-40 bg-foreground border-b border-background/15">
        <div className="flex items-center justify-between px-4 sm:px-8 h-16">
          <Link to="/master" className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-sm bg-amber-500 flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-foreground" />
            </div>
            <div>
              <div className="font-display font-black tracking-tighter text-lg leading-none">
                LASTİK OTELİ
              </div>
              <div className="label-eyebrow text-amber-400 mt-1">Master Panel</div>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <Link
              to="/master/profil"
              className="hidden sm:block text-right hover:opacity-80 transition-opacity"
              data-testid="master-profile-link"
              title="Profil bilgilerini düzenle"
            >
              <div className="text-xs text-background/50 uppercase tracking-wider">Master Admin</div>
              <div className="text-sm font-semibold" data-testid="master-user-name">{user?.name}</div>
            </Link>
            <Button
              variant="outline"
              size="sm"
              className="rounded-sm bg-transparent border-background/30 text-background hover:bg-background hover:text-foreground"
              onClick={handleLogout}
              data-testid="master-logout-btn"
            >
              <LogOut className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Çıkış</span>
            </Button>
          </div>
        </div>
        <nav className="flex border-t border-background/10 overflow-x-auto">
          {NAV.map((item) => <NavItem key={item.to} {...item} />)}
        </nav>
      </header>
      <main className="bg-background text-foreground min-h-[calc(100vh-128px)]">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
